import { createContext, useContext, useState } from 'react'

export type AppMode = 'personal' | 'business'

const MODE_KEY = 'pb-app-mode'

interface ModeCtx {
  mode: AppMode
  setMode: (m: AppMode) => void
}

const ModeContext = createContext<ModeCtx>({
  mode: 'personal',
  setMode: () => {},
})

export function ModeProvider({ children }: { children: React.ReactNode }) {
  const [mode, setModeState] = useState<AppMode>(() => {
    const stored = localStorage.getItem(MODE_KEY)
    return stored === 'business' ? 'business' : 'personal'
  })

  const setMode = (m: AppMode) => {
    setModeState(m)
    localStorage.setItem(MODE_KEY, m)
  }

  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  )
}

export const useMode = () => useContext(ModeContext)
